<p-card styleClass="detail-card">
  <div class="section-header">
    <div>
      <h3>Résultats de recherche</h3>
      <p>
        @if (totalCount > results.length) {
          {{ results.length }} intervention{{ results.length > 1 ? 's' : '' }}
          affichée{{ results.length > 1 ? 's' : '' }} sur {{ totalCount }} pour
          « {{ query }} »
        } @else {
          {{ results.length }} intervention{{ results.length > 1 ? 's' : '' }}
          programmée{{ results.length > 1 ? 's' : '' }} pour « {{ query }} »
        }
      </p>
    </div>
    <button
      type="button"
      class="close-btn"
      (click)="closed.emit()"
      aria-label="Effacer la recherche"
      title="Effacer la recherche"
    >
      <i class="pi pi-times"></i>
    </button>
  </div>

  @if (loading) {
    <div class="empty-panel">
      <i class="pi pi-spin pi-spinner"></i>
      <p>Chargement des interventions…</p>
    </div>
  } @else if (results.length > 0) {
    <div class="tour-affairs-list">
      @for (item of results; track $index) {
        <button
          type="button"
          class="tour-affair-item search-item"
          [class.highlighted]="
            item.id != null && selectedInterventionId === item.id
          "
          (click)="resultSelected.emit(item)"
        >
          <div class="item-topline">
            <span class="affair-name">{{ item.title }}</span>
            @if (item.dateLabel) {
              <span class="date-chip">{{ item.dateLabel }}</span>
            }
          </div>
          <div class="item-meta">
            @if (item.location) {
              <div class="item-row">
                <i class="pi pi-map-marker"></i>
                <span>{{ item.location }}</span>
              </div>
            }
            @if (item.technicianName) {
              <div class="item-row">
                <i class="pi pi-user"></i>
                <span>{{ item.technicianName }}</span>
              </div>
            }
            @if (item.latitude == null || item.longitude == null) {
              <div class="item-row no-geo">
                <i class="pi pi-exclamation-triangle"></i>
                <span>Non géolocalisée (invisible sur la carte)</span>
              </div>
            }
          </div>
        </button>
      }
    </div>
  } @else {
    <div class="empty-panel">
      <i class="pi pi-search"></i>
      <p>Aucune intervention programmée ne correspond à « {{ query }} ».</p>
    </div>
  }
</p-card>
